// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'clock';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.125 9a7.875 7.875 0 1 0 15.75 0 7.875 7.875 0 0 0-15.75 0zM9 9V6.187M9 9l3.515 3.516'
  />
);

export const viewBox = '0 0 18 18';
